/**
 * Registro de módulos F-22 por año tributario y régimen.
 * Cada entrada exporta: createInitialState, recalculate, SECTIONS, y componentes de secciones.
 * Al agregar un nuevo año o régimen, solo se registra aquí.
 */
import * as at2026_14d3 from './2026/14d3';
import * as at2026_14d8 from './2026/14d8';

const registry = {
  2026: {
    '14d3': at2026_14d3,
    '14d8': at2026_14d8,
  },
};

/**
 * Obtiene el módulo correspondiente al año tributario y régimen.
 * @param {number} anioTributario
 * @param {string} regimen - '14d3' o '14d8'
 * @returns {Object|null} Módulo con createInitialState, recalculate, SECTIONS, etc.
 */
export const getModule = (anioTributario, regimen) => {
  return registry[anioTributario]?.[regimen] || null;
};

/**
 * Verifica si existe un módulo implementado (con secciones definidas) para el año y régimen dados.
 */
export const hasModule = (anioTributario, regimen) => {
  const mod = registry[anioTributario]?.[regimen];
  return !!mod && Array.isArray(mod.SECTIONS) && mod.SECTIONS.length > 0;
};

/**
 * Retorna los años tributarios disponibles.
 */
export const getAvailableYears = () => Object.keys(registry).map(Number);

/**
 * Retorna los regímenes disponibles para un año tributario.
 */
export const getAvailableRegimens = (anioTributario) => {
  return registry[anioTributario] ? Object.keys(registry[anioTributario]) : [];
};
